import { app } from "@microsoft/teams-js";
import { TeamsIntegrationReferenceType } from "@teams/types";
import { IntegrationAutoLinkDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { isError } from "../services/ChannelApi";
import { integrationsApi } from "../services/IntegrationsApi";

export const useAutolinkIntegrations = (
  referenceId: string,
  referenceType: TeamsIntegrationReferenceType
) => {
  const [isLoadingAutolinkIntegrations, setIsLoadingAutolinkIntegrations] =
    useState<boolean>(false);
  const [autolinkIntegrations, setAutolinkIntegrations] = useState<IntegrationAutoLinkDTO[]>([]);
  const [autolinkIntegrationsError, setAutolinkIntegrationsError] = useState<Error>();

  const loadIntegrations = useCallback(
    async (context: app.Context) => {
      setIsLoadingAutolinkIntegrations(true);
      const integrations = await integrationsApi.loadIntegrations(
        context,
        referenceId,
        referenceType,
        ["autolink"]
      );
      setIsLoadingAutolinkIntegrations(false);

      if (isError(integrations)) {
        setAutolinkIntegrationsError(integrations);
        return;
      }

      setAutolinkIntegrations(integrations);
    },
    [referenceId, referenceType]
  );

  return {
    isLoadingAutolinkIntegrations,
    loadIntegrations,
    autolinkIntegrations,
    autolinkIntegrationsError,
  };
};
